import type {FileApiModel} from '../../../api/media/file';
import type {Nullable} from '../../utility-types';

const THUMBS = [250, 500, 1000, 'image', 'plot', 'playable'] as const;

export type IFileSrc = Omit<
  Required<FileApiModel['src']>['original'],
  'url'
> & {
  url: Nullable<string>;
};

export type IFileSrcThumb = (typeof THUMBS)[number];

export const getFileSrc = (
  file?: Nullable<FileApiModel>,
  thumb?: IFileSrcThumb,
): Required<IFileSrc> => {
  const emptySrc: IFileSrc = {
    mimetype: '',
    url: null,
  };

  const src = file && file.src;

  if (!src) {
    return emptySrc;
  }

  if (thumb) {
    const _thumb = THUMBS.includes(thumb) ? thumb : 'original';

    const thumbKey =
      typeof _thumb === 'number' ? `thumb${_thumb}x${_thumb}` : _thumb;

    if (src[thumbKey] && src[thumbKey].url) {
      return src[thumbKey];
    }

    return src.original?.url ? (src.original as IFileSrc) : emptySrc;
  }

  return src.original?.url ? (src.original as IFileSrc) : emptySrc;
};
